import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TokenService } from './components/auth/token.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
    constructor(private tokenService: TokenService) {}
    intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
            // Get the auth header from the service.
            const authHeader = this.tokenService.getToken();
            //const authHeader = "asdasdsad";
            if (authHeader){
                // Clone the request to add the new header.
                const authReq = req.clone({headers: req.headers.set('Token', authHeader).set('X-Requested-With','XMLHttpRequest')});
                // Pass on the cloned request instead of the original request.
                return next.handle(authReq);
            }
            return next.handle(req);        
    }
}



// WEBPACK FOOTER //
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/app.interceptor.ts